<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<span id="Page_vii" title="[vii]"></span>
<h2 class="nobreak" id="pgepubid00002">CONTENTS</h2>
</div>
<table class="calibre8" summary="">
<tbody class="calibre9"><tr class="calibre10"><td class="tdr"><span class="small">CHAPTER</span></td>
<td class="tdr" colspan="2"><span class="small">PAGE</span></td>
</tr>
<tr class="calibre10"><td class="tdr">I.</td>
<td class="calibre13"> <span class="smcap">The Homestead in the Clearing</span></td>
<td class="tdr"><a href="#/Text/Section0006#Page_1">       1</a></td>
</tr>
<tr class="calibre10"><td class="tdr">II.</td>
<td class="calibre13"> <span class="smcap">White Buffalo Brings News</span></td>
<td class="tdr"><a href="#/Text/Section0007#Page_10">         10</a></td>
</tr>
<tr class="calibre10"><td class="tdr">III.</td>
<td class="calibre13"> <span class="smcap">In the Forest</span></td>
<td class="tdr"><a href="#/Text/Section0008#Page_21">                    21</a></td>
</tr>
<tr class="calibre10"><td class="tdr">IV.</td>
<td class="calibre13"> <span class="smcap">Deer Shooting by Moonlight</span></td>
<td class="tdr"><a href="#/Text/Section0009#Page_31">        31</a></td>
</tr>
<tr class="calibre10"><td class="tdr">V.</td>
<td class="calibre13"> <span class="smcap">An Unexpected Meeting</span></td>
<td class="tdr"><span href="#/Text/Section0010#Page_41" title="Link target outside of Sample">             41</span></td>
</tr>
<tr class="calibre10"><td class="tdr">VI.</td>
<td class="calibre13"> <span class="smcap">George Washington the Surveyor</span></td>
<td class="tdr"><span href="#/Text/Section0011#Page_54" title="Link target outside of Sample">      54</span></td>
</tr>
<tr class="calibre10"><td class="tdr">VII.</td>
<td class="calibre13"> <span class="smcap">The Camp in the Mountain Gap</span></td>
<td class="tdr"><span href="#/Text/Section0012#Page_64" title="Link target outside of Sample">       64</span></td>
</tr>
<tr class="calibre10"><td class="tdr">VIII.</td>
<td class="calibre13"> <span class="smcap">On to Annapolis</span></td>
<td class="tdr"><span href="#/Text/Section0013#Page_74" title="Link target outside of Sample">                   74</span></td>
</tr>
<tr class="calibre10"><td class="tdr">IX.</td>
<td class="calibre13"> <span class="smcap">A Storm in the Mountains</span></td>
<td class="tdr"><span href="#/Text/Section0014#Page_83" title="Link target outside of Sample">            83</span></td>
</tr>
<tr class="calibre10"><td class="tdr">X.</td>
<td class="calibre13"> <span class="smcap">An Unsuccessful Mission</span></td>
<td class="tdr"><span href="#/Text/Section0015#Page_93" title="Link target outside of Sample">              93</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XI.</td>
<td class="calibre13"> <span class="smcap">Dave Becomes Washington’s Assistant</span></td>
<td class="tdr"><span href="#/Text/Section0016#Page_102" title="Link target outside of Sample">       102</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XII.</td>
<td class="calibre13"> <span class="smcap">Surveying Along the Shenandoah</span></td>
<td class="tdr"><span href="#/Text/Section0017#Page_111" title="Link target outside of Sample">           111</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XIII.</td>
<td class="calibre13"> <span class="smcap">A Bear Hunt</span></td>
<td class="tdr"><span href="#/Text/Section0018#Page_119" title="Link target outside of Sample">                      119</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XIV.</td>
<td class="calibre13"> <span class="smcap">Home Coming in the Snow</span></td>
<td class="tdr"><span href="#/Text/Section0019#Page_129" title="Link target outside of Sample">           129</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XV.</td>
<td class="calibre13"> <span class="smcap">The Situation Between the English, French, and Indians</span></td>
<td class="tdr"><span href="#/Text/Section0020#Page_138" title="Link target outside of Sample">  138</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XVI.</td>
<td class="calibre13"> <span class="smcap">Dave’s Departure for the West</span></td>
<td class="tdr"><span href="#/Text/Section0021#Page_146" title="Link target outside of Sample">       146</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XVII.</td>
<td class="calibre13"> <span class="smcap">Carried Down the River</span></td>
<td class="tdr"><span href="#/Text/Section0022#Page_154" title="Link target outside of Sample">           154</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XVIII.</td>
<td class="calibre13"> <span class="smcap">Dave Visits an Indian Village</span></td>
<td class="tdr"><span href="#/Text/Section0023#Page_163" title="Link target outside of Sample">       163</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XIX.</td>
<td class="calibre13"> <span class="smcap">The Trading-Post on the Kinotah</span></td>
<td class="tdr"><span href="#/Text/Section0024#Page_172" title="Link target outside of Sample">       172</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XX.</td>
<td class="calibre13"> <span class="smcap">An Alarming Discovery</span></td>
<td class="tdr"><span href="#/Text/Section0025#Page_181" title="Link target outside of Sample">                  181</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXI.</td>
<td class="calibre13"> <span class="smcap">The Defence of the Trading-Post</span></td>
<td class="tdr"><span href="#/Text/Section0026#Page_191" title="Link target outside of Sample">       191</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXII.</td>
<td class="calibre13"> <span class="smcap">Washington’s Mission to French Creek</span></td>
<td class="tdr"><span href="#/Text/Section0027#Page_201" title="Link target outside of Sample">       201</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXIII.</td>
<td class="calibre13"> <span class="smcap">An Indian’s Treachery</span></td>
<td class="tdr"><span href="#/Text/Section0028#Page_210" title="Link target outside of Sample">      210</span><span id="Page_viii" title="[viii]"></span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXIV.</td>
<td class="calibre13"> <span class="smcap">Washington at Will’s Creek</span></td>
<td class="tdr"><span href="#/Text/Section0029#Page_219" title="Link target outside of Sample">      219</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXV.</td>
<td class="calibre13"> <span class="smcap">Soldiers of the Wilderness</span></td>
<td class="tdr"><span href="#/Text/Section0030#Page_229" title="Link target outside of Sample">      229</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXVI.</td>
<td class="calibre13"> <span class="smcap">The Retreat to Fort Necessity</span></td>
<td class="tdr"><span href="#/Text/Section0031#Page_239" title="Link target outside of Sample">      239</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXVII.</td>
<td class="calibre13"> <span class="smcap">Battle at Great Meadows</span></td>
<td class="tdr"><span href="#/Text/Section0032#Page_249" title="Link target outside of Sample">      249</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXVIII.</td>
<td class="calibre13"> <span class="smcap">The Fall of the Trading-Post</span></td>
<td class="tdr"><span href="#/Text/Section0033#Page_259" title="Link target outside of Sample">     259</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXIX.</td>
<td class="calibre13"> <span class="smcap">Braddock’s Defeat and Fall</span></td>
<td class="tdr"><span href="#/Text/Section0034#Page_268" title="Link target outside of Sample">      268</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXX.</td>
<td class="calibre13"> <span class="smcap">Fighting in the Forest</span></td>
<td class="tdr"><span href="#/Text/Section0035#Page_278" title="Link target outside of Sample">      278</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXXI.</td>
<td class="calibre13"> <span class="smcap">Father and Son</span></td>
<td class="tdr"><span href="#/Text/Section0036#Page_286" title="Link target outside of Sample">      286</span></td>
</tr>
<tr class="calibre10"><td class="tdr">XXXII.</td>
<td class="calibre13"> <span class="smcap">Back to the Homestead—Conclusion</span></td>
<td class="tdr"><span href="#/Text/Section0037#Page_295" title="Link target outside of Sample">      295</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?5ae8cb69